import React, { useState } from 'react'
import { Card, Col, Flex, Form, Row, Typography, Button } from 'antd'
import { AppointmentCalender, Appointmenttable, ModuleTopHeading, SearchInput } from '../../components';

const { Text } = Typography
const Appointment = () => {
    const [visible, setVisible] = useState(false)
    const [edititem, setEditItem] = useState(null)
    const [form] = Form.useForm();

    return (
        <>
            <Card className='shadow-d radius-12'>
                <Row gutter={[24, 24]}>
                    <Col span={24}>
                        <Flex justify='space-between' align='center' gap={10} wrap>
                            <ModuleTopHeading level={4} name='Appointment' />
                        </Flex>
                    </Col>
                    <Col span={24}>
                    <Appointmenttable {...{ setEditItem, setVisible }} />    
                    </Col>
                </Row>
            </Card>
        </>
    )
}

export { Appointment }
